import type { PropsWithChildren } from 'react'

import TableCell from '@mui/material/TableCell'
import clsx from 'clsx'
import { appDay } from 'shared/day'
import { roundToDecimal } from 'shared/utils'

import type { Campaign } from '../../types'

export const formatPercent = (value?: null | number) =>
	value ? `${roundToDecimal(value)}%` : '...'

export function LastCells({
	children,
	created,
	statistics,
	withScroll
}: PropsWithChildren<
	Pick<Campaign, 'created' | 'id' | 'statistics'> & {
		withScroll?: boolean
	}
>) {
	return (
		<TableCell
			className={withScroll ? 'common-wrapper-scroll' : 'common-wrapper'}
		>
			<div
				style={{
					display: 'flex'
				}}
			>
				<div
					className={clsx(
						'contacts  text-accent',
						withScroll
							? 'width-with_scroll-percent'
							: 'width-with-out_scroll-percent'
					)}
				>
					{formatPercent(statistics.reply_rate)}
				</div>

				<div
					className={
						withScroll
							? 'width-with_scroll-teams'
							: 'width-with-out_scroll-teams'
					}
				>
					<div className='start-end-date-teams'>
						{created ? appDay(created).format('DD MMM YYYY') : '...'}
					</div>
				</div>

				<div
					className='column-width'
					onClick={event => event.stopPropagation()}
				>
					{children}
				</div>
			</div>
		</TableCell>
	)
}
